import React, { useRef, useEffect, useState } from 'react';

export type SectionProgressMobileProps = {
  total: number;
  currentIndex: number;
};

const CIRCLE_SIZE = 18;

const SectionProgressMobile: React.FC<SectionProgressMobileProps> = ({
  total,
  currentIndex,
}) => {
  const items = Array.from({ length: total });
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [lineBreaks, setLineBreaks] = useState<boolean[]>([]);

  // Calcular los line-breaks, para evitar lineas que no se conectan a círculos
  useEffect(() => {
    const checkLineBreaks = () => {
      const newLineBreaks: boolean[] = [];

      itemRefs.current.forEach((ref, index) => {
        if (!ref || index === total - 1) return;

        const currentTop = ref.getBoundingClientRect().top;
        const nextRef = itemRefs.current[index + 1];
        if (!nextRef) return;

        const nextTop = nextRef.getBoundingClientRect().top;
        newLineBreaks[index] = Math.abs(currentTop - nextTop) > 2;
      });

      setLineBreaks(newLineBreaks);
    };

    checkLineBreaks();
    window.addEventListener('resize', checkLineBreaks);
    return () => window.removeEventListener('resize', checkLineBreaks);
  }, [total]);

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(${CIRCLE_SIZE}px, 1fr))`,
        maxWidth: '100%',
        gap: '40px',
        alignItems: 'center',
        justifyItems: 'center',
        margin: '0 20px',
      }}
    >
      {items.map((_, i) => (
        <div
          key={i}
          ref={(el) => (itemRefs.current[i] = el)}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          {/* Círculo */}
          <div
            style={{
              width: CIRCLE_SIZE,
              height: CIRCLE_SIZE,
              borderRadius: '50%',
              border: '1px solid var(--primary)',
              backgroundColor:
                i <= currentIndex ? 'var(--primary)' : 'transparent',
              boxShadow:
                i <= currentIndex
                  ? '0 0 0 3px #ffffff, 0 0 0 4px var(--primary)'
                  : '0 0 0 3px #ffffff, 0 0 0 4px #F4F4F4',
            }}
          />

          {/* Línea conectora */}
          {i < total - 1 && !lineBreaks[i] && (
            <div
              style={{
                position: 'absolute',
                left: CIRCLE_SIZE + 4,
                right: -36,
                height: 1,
                backgroundColor:
                  i < currentIndex ? 'var(--primary)' : '#F4F4F4',
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SectionProgressMobile;
